import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const Album: React.FC<CreateIconComponentProps> = (props) => (
  <CreateIconComponent viewBox="0 0 60 60" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 12.212c-3.499-2.38-10.353-4.659-18.92-1.485a2.292 2.292 0 00-1.497 2.149v.625H4.792A2.292 2.292 0 002.5 15.793v33.333a2.292 2.292 0 002.292 2.291h50.416a2.292 2.292 0 002.292-2.291V15.793a2.292 2.292 0 00-2.292-2.292h-4.791v-.625c0-.96-.597-1.816-1.496-2.15C40.353 7.554 33.499 9.833 30 12.213zM7.083 18.084h2.5v26.042a2.292 2.292 0 003.05 2.163c1.911-.67 7.045-1.428 12.82.545H7.083v-28.75zm7.084-2.291V14.53c6.44-1.875 11.223.052 13.333 1.523v26.644c-5.154-1.887-9.99-1.941-13.333-1.447V15.793zm38.75 2.291h-2.5v26.042a2.292 2.292 0 01-3.05 2.163c-1.911-.67-7.045-1.428-12.82.545h18.37v-28.75zm-7.084-2.291V14.53c-6.44-1.875-11.223.052-13.333 1.523v26.644c5.154-1.887 9.99-1.941 13.333-1.447V15.793z"
    />{' '}
  </CreateIconComponent>
);

export default Album;
